import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header, { BreadcrumbItem } from '../components/Header';
import AboutModal from '../components/AboutModal';
import { useAuth } from '../context/AuthContext';
import { useLocale } from '../context/LocaleContext';
import RootLanding from '../components/RootLanding';
import InvitationsPanel from '../components/InvitationsPanel';
import styles from '../styles/homePage.module.css';

interface HomePageProps {
  user?: any;
  onLogout: () => void;
  onLogin: () => void;
  onCreateAccount?: () => void;
}

const HomePage: React.FC<HomePageProps> = ({ user: userProp, onLogout, onLogin, onCreateAccount }) => {
  const { user: authUser } = useAuth();
  const { t } = useLocale();
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const [showInvitationsPanel, setShowInvitationsPanel] = useState(false);
  const [hasShownInvitation, setHasShownInvitation] = useState(false);

  const breadcrumbs: BreadcrumbItem[] = [
    { label: t('nav.home'), path: '/', active: false }
  ];

  // Check for invitation token on mount
  useEffect(() => {
    const invitationToken = searchParams.get('invitation');
    if (invitationToken && !authUser && !hasShownInvitation) {
      if (onCreateAccount) {
        onCreateAccount();
        setHasShownInvitation(true);
      }
    } else if (invitationToken && authUser) {
      setShowInvitationsPanel(true);
    }
  }, [searchParams, authUser, onCreateAccount, hasShownInvitation]);

  const user = userProp ?? authUser;

  return (
    <div className={styles.homePage}>
      <Header 
        breadcrumbs={breadcrumbs}
        user={user}
        onLogout={onLogout}
        onLogin={onLogin}
      />

      <main className={styles.mainContent}>
        <RootLanding />
      </main>
      
      <AboutModal
        isOpen={isAboutOpen}
        onClose={() => setIsAboutOpen(false)}
      />
      
      <InvitationsPanel
        isOpen={showInvitationsPanel}
        onClose={() => setShowInvitationsPanel(false)}
        onInvitationResponded={() => {
          setShowInvitationsPanel(false);
        }}
      />
    </div>
  );
};

export default HomePage; 